export class FAXDATA {

    ID: string;
    VQuad_Timestamp: Date;
    Call_Timestamp: Date;
    VQuad_Location: string;
    VQuad_PhoneID: string;
    GPS_Position: string;
    GPS_Lat: number;
    GPS_Long: number;
    Fax_Duration: number;
    Fax_Event: string;
    Fax_Error: string;
    Modem: string;
    Starting_Speed: number;
    Final_Speed: number;
    Completed_Pages: number;
    Sent_Lines: number;
    Bad_Lines: number;
    Encoding: string;
    Resolution: string;
    ECM: string;

    CallType_Orig: string;
    CallType_Term: string;
    VQuad_CallID: string;
  
   //Call_Control_Event: string;
  constructor() {
     this.ID = "";
     this.VQuad_Timestamp = new Date();
     this.Call_Timestamp = new Date();
     this.VQuad_Location = "";
     this.VQuad_PhoneID = "";
     this.GPS_Position = "";
     this.GPS_Lat = 0;
     this.GPS_Long = 0;
     this.Fax_Duration = 0;
     this.Fax_Event = "";
     this.Fax_Error = "";
     this.Modem = "";
     this.Starting_Speed = 0;
     this.Final_Speed = 0;
     this.Completed_Pages = 0;
     this.Sent_Lines = 0;
     this.Bad_Lines = 0;
     this.Encoding = "";
     this.Resolution = "";
     this.ECM = "";
    
     this.CallType_Orig = "";
     this.CallType_Term = "";
     this.VQuad_CallID = "";
  
   //this.Call_Control_Event = "";

    }
}
